const benefitsPage = {
  page: '/pyme/beneficios',
  page_title: 'Pyme – Beneficios',
};

const benefitsPageEvents = {
  home: {
    ...benefitsPage,
    action_type: 'Pageview',
    action: 'PYME – Beneficios',
  },
  clickQuoteHero: {
    ...benefitsPage,
    action_type: 'click',
    action: 'Click link Cotiza ahora – Beneficios',
  },

  hiringFloatClick: {
    ...benefitsPage,
    action_type: 'click',
    action: 'Click link Cotiza online – Beneficios – Pop-up',
  },

  benefitsClick: (label: string) => ({
    ...benefitsPage,
    action_type: 'click',
    action: `Click link ${label} – Beneficios`,
  }),

  quoteFooter: {
    ...benefitsPage,
    action: 'Click link Cotiza ahora footer – Beneficios',
  },
};

export { benefitsPage, benefitsPageEvents };
